export const viewsConstants = {
    createEvent: {
        stepOne: "Step One",
        stepTwo: "Step Two",
    },
    error: {
        applicationError: "Application Error",
        description: "The application encountered an unexpected error and had to stop.",
        errorStatus: "Error Status: ",
        stackTrace: "Stack Trace: ",
        title: "Internal Application Error",
        unexpectedErrorOccurred: "An unexpected error occurred",
    },
    forbidden: { title: "You have no access to view this page" },
    notFound: {
        goToDashboard: "Go to Dashboard",
        pageNotFound: "Page Not Found",
        title: "404",
    },
    offline: {
        description: "It looks like you've lost your internet connection. Please check your network settings and try again.",
        indicator: "You are currently offline. Please check your internet connection.",
        title: "No Internet Connection",
    },
    updateEvent: {
        eventDetails: {
            eventInfo: "Event Info",
            eventLink: "Event Link",
            noOverlaysNote: "No overlays uploaded in this category",
            overlaysTitle: "Overlays Images",
            templateInfo: "Template Info",
            uploadingNote: "Upload or Drag Image here. Aspect ratio will be detected automatically and assigned to portrait or landscape.",
        },
        headshot: {
            guestForm: {
                action: "Action",
                addAtLeastOneOption: "Add at least one option",
                addCustomField: "Add Custom Field",
                addField: "Add Field",
                addOption: "+ Add Option",
                cancel: "Cancel",
                customFields: "Custom Fields",
                dropdownOptions: "Dropdown Options *",
                fieldName: "Field Name",
                optional: "Optional",
                optionPlaceholder: "Option",
                publicForm: "Public Form",
                required: "Required",
                requiredField: "Required Field",
                requiredFieldDescription: "Users must fill this field to proceed",
                standardFields: "Standard Fields",
                tabletForm: "Tablet Form",
                type: "Field Type",
            },
            headshotSetting: "Headshot Setting",
            howItWorks: "How It Works",
            howItWorksSteps: [
                {
                    description: "Guest receives gallery link via email/SMS after session",
                    title: "Photos Delivered",
                },
                {
                    description: "Guest picks and ranks preferred photos for retouch",
                    title: "Guest Selects",
                },
                {
                    description: "Admin retouches, uploads, and sends final gallery to guest",
                    title: "Retouch & Send",
                },
            ],
            maxRetouchSelections: "Maximum Retouch Selections",
            photosNaming: {
                addedAutomaticallyAtEnd: "Added automatically at the end",
                chooseFieldAndSeparatorDescription: "Choose a field and a separator for each position. The sequence number is added automatically at the end.",
                defaultName: "Default Name",
                defaultNameExample: "lastname.firstname_phonenumber_001.jpg",
                defaultNamingConventionDescription: "When custom naming is off, files are delivered using the guest's name and a sequence number.",
                defaultNamingConventionTitle: "Default Photo Naming Convention",
                enableCustomNaming: "Enable Custom Naming",
                enableCustomNamingDescription: "Apply a consistent file name to every delivered headshot photo.",
                fieldPlaceholder: "Type",
                fileName: "File name",
                preview: "Preview",
                previewExample: "001.jpg",
                separator: "Separator",
                separatorDefaultValue: "_",
                separatorPlaceholder: "Sep",
                sequence: "Sequence",
                sequenceDefaultValue: "001",
                setNamingConvention: "Set Naming convention",
                title: "Photos Naming Convention",
            },
            photosPerGuest: "Photos per Guest",
            registrationInfo: {
                formTitle: "Form Title",
                uploadLogo: "Upload Logo",
                uploadLogoHelper: "SVG, PNG, JPG or GIF (max. 3MB)",
            },
            registrationQRCode: "Registration QR Code",
            retouchSelection: "Retouch Selection",
            retouchSelectionDescription: "Allow guests to select their preferred photos for professional retouching after the event",
            retouchSetting: "Retouch Setting",
            setMaxRetouchSelectionsDescription: "Set how many photos each guest can select for retouching. Guests will rank their selections by preference.",
        },
        publicPage: {
            bannersImagesTitle: "Banners Images",
            pageActionsTitle: "Page Actions",
        },
        shareDetails: {
            domainTitle: "Add Custom Email Domain",
            templateLogoTitle: "Event Template Logo",
        },
    },
};
